<template>
  <div style="margin: 10px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <button class="selectAll" @click="goback" style="margin-top: 0px">
            返回
          </button>
          <br />
          <h4 class="title" style="line-height: 70px; margin-top: 30px">
            表单数据项
          </h4>
          <el-row>
            <el-col :span="24">
              <el-table
			  	:default-sort = "{prop:'order', order: 'ascending'}"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                size="mini"
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                border
                :header-cell-style="{ background: '#E5E7EE', color: '#000000' }"
                row-key="id"
              >
                <!-- <el-table-column type="selection" width="55" align="center">
								</el-table-column> -->
                <el-table-column prop="order" label="排序" align="center" sortable>
				</el-table-column>
				<el-table-column
                  align="center"
                  :prop="dropCol[index].prop"
                  :label="item.label"
                  v-for="(item, index) in col"
                  :key="`col_${index}`"
                >
                </el-table-column>
                <el-table-column
                  prop="dataType"
                  label="数据类型"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.dataType == 0
                        ? "单选"
                        : scope.row.dataType == 1
                        ? "多选"
                        : scope.row.dataType == 2
                        ? "单行文本"
                        : scope.row.dataType == 3
                        ? "多行文本"
                        : scope.row.dataType == 4
                        ? "时间"
                        : scope.row.dataType == 5
                        ? "文件上传"
                        : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="mustInputFlag"
                  label="是否必输"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.mustInputFlag == 0
                        ? "否"
                        : scope.row.mustInputFlag == 1
                        ? "是"
                        : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="更多操作">
                  <template slot-scope="scope">
                    <el-button
                      type="success"
                      icon="el-icon-edit"
                      circle
                      size="small"
                      style="margin-left: 0px"
                      @click.native.prevent="add('1', scope.row)"
                    ></el-button>
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      style="margin-left: 0px"
                      @click.native.prevent="deleteRow(scope.$index, scope.row)"
                      size="small"
                    >
                    </el-button>
                    <el-button
                      type="primary"
                      icon="el-icon-top"
                      circle
                      size="small"
                      style="margin-left: 0px"
                      @click.native.prevent="order('0', scope.row)"
                    ></el-button>
                    <el-button
                      type="primary"
                      icon="el-icon-bottom"
                      circle
                      size="small"
                      style="margin-left: 0px"
                      @click.native.prevent="order('1', scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tableFooter">
                <!-- <button class="selectAll" @click="toggleSelection(tableData)"
									style="float: left;">全选</button>
								<button class="del" @click="del" style="float: left;margin-left: 10px;">批量删除</button> -->
                <input
                  class="add"
                  @click="add('0')"
                  type="button"
                  value="添加数据项"
                  style="float: left"
                />
              </div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
    >
      <el-form
        label-position="left"
        label-width="90px"
        :model="dataDialog"
        :rules="rules"
        ref="dataDialog"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="dataDialog.name" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="提示框">
          <el-input v-model="dataDialog.tips" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="数据类型">
          <el-select
            v-model="dataDialog.dataType"
            placeholder="请选择数据类型"
            size="mini"
          >
            <el-option label="单选" value="0">单选</el-option>
            <el-option label="多选" value="1">多选</el-option>
            <el-option label="单行文本" value="2">单行文本</el-option>
            <el-option label="多行文本" value="3">多行文本</el-option>
            <el-option label="时间" value="4">时间</el-option>
            <el-option label="文件上传" value="5">文件上传</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必输">
          <el-select
            v-model="dataDialog.mustInputFlag"
            placeholder="请选择是否必输"
            size="mini"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最大长度">
          <el-input v-model="dataDialog.maxLength" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="selectAll"
          @click="Onsubmit('dataDialog')"
          style="margin-top: -30px"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		data() {
			return {
                dataDialog: {
					          order:'',
                    id:'',
                    formId:'',
					name: '',
					tips: '',
					dataType: '',
					mustInputFlag: '',
                    maxLength:'',
				},
                rules:{
					name:[
						{required:true,message:'请输入栏目名称',tigger:'blur'}
					]
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false,
				srcList: '',
				visiable: false,
                formId:'',
				col: [
					{
						label: '数据项名',
						prop: 'name'
					},
					{
						label: '提示框',
						prop: 'tips'
					},
					{
						label: '最大长度',
						prop: 'maxLength'
					},
				],
				dropCol: [
					{
						label: '数据项名',
						prop: 'name'
					},
					{
						label: '提示框',
						prop: 'tips'
					},
					{
						label: '最大长度',
						prop: 'maxLength'
					},
				],
                dialogVisible:false,
                isUpdate:false,
			}
		},
		created() {
            console.log(this.$route.query.id)
            this.formId = this.$route.query.id
			this.getData(this.currentPage, this.pageSize)
		},
		mounted() {
			this.rowDrop()
		},
		methods: {
			// 行拖拽
			rowDrop() {
				const tbody = document.querySelector('.el-table__body-wrapper tbody')
				const _this = this
				this.Sortable.create(tbody, {
					onEnd({
						newIndex,
						oldIndex
					}) {
						const currRow = _this.tableData.splice(oldIndex, 1)[0]
						_this.tableData.splice(newIndex, 0, currRow)
					}
				})
			},
			
			//获取列表数据
			getData(currentPage, pageSize) {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: '/api/v1/form/item/page',
					params: {
						pageNum: currentPage,
						pageSize: pageSize,
						formId:this.formId,
					},
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
                        console.log(res,'数据项列表')
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.data.msg)
					}
				})
			},
            // 添加数据项
            add(type,rows) {
                if(type=='0'){
					this.title='数据项信息'
                    this.dialogVisible = true;
                    this.isUpdate = false;
                    this.dataDialog = {}
                }
                else if(type=='1'){
					this.title='修改数据项'
                    this.dialogVisible = true;
                    this.isUpdate = true;
                    this.dataDialog.id = rows.id
                    this.dataDialog.formId = rows.formId
                    this.dataDialog.name = rows.name
                    this.dataDialog.tips = rows.tips
                    this.dataDialog.dataType = rows.dataType
                    this.dataDialog.mustInputFlag = rows.mustInputFlag
                    this.dataDialog.maxLength = rows.maxLength
                }
                
			},
			// 修改排序
			order(type,rows) {
				console.log(type)
				console.log(rows)
				var obj = this;
				obj.$http({
				    method: 'get',
				    url:'/api/v1/form/item/change/order',
				    params: {
				        id:rows.id,
						type:type,
				    },
				    }).then((res) => {
				        if (res.status == 200) {
                            console.log(res,'修改排序')
							obj.$message.success('修改成功')
							this.getData()
				           		
				        } else {
				           	obj.$message.error(res.message)
				        }
				})         
			},
            // 提交数据
            Onsubmit(formName) {
                if(!this.isUpdate){
                    this.$refs[formName].validate((valid) => {
				          if (valid) {
				           var obj = this;
				           obj.$http({
				           	method: 'post',
				           	url: '/api/v1/form/item/add',
				           	data: {
				           		formId:this.formId,
                                name:this.dataDialog.name,
                                tips:this.dataDialog.tips,
                                dataType:this.dataDialog.dataType,
                                mustInputFlag:this.dataDialog.mustInputFlag ? this.dataDialog.mustInputFlag : '',
                                maxLength:this.dataDialog.maxLength==='' ? '0' : this.dataDialog.maxLength,
				           	},
				           }).then((res) => {
				           	if (res.status == 200) {
                                console.log(res,'添加数据项')
				           		this.dialogVisible = false
				           		this.getData()
				           		this.dataDialog.name=''
                                this.dataDialog.tips=''
                                this.dataDialog.dataType=''
                                this.dataDialog.mustInputFlag = ''
                                this.dataDialog.maxLength = ''
				           	} else {
				           		obj.$message.error(res.message)
				           	}
				           })
				          } else {
				            console.log('error submit!!');
				            return false;
				          }
				        });
				
                }
                else{
                    this.onUpdate(formName)
                }
			},
			//修改/添加
			onUpdate(formName) {
				this.$refs[formName].validate((valid) => {
				          if (valid) {
				           var obj = this;
				           obj.$http({
				           	method: 'post',
				           	url: '/api/v1/form/item/update',
				           	data: {
                                id:this.dataDialog.id,
				           		formId:this.formId,
                                name:this.dataDialog.name,
                                tips:this.dataDialog.tips,
                                dataType:this.dataDialog.dataType,
                                mustInputFlag:this.dataDialog.mustInputFlag ? this.dataDialog.mustInputFlag : '',
                                maxLength:this.dataDialog.maxLength==='' ? '0' : this.dataDialog.maxLength,
				           	},
				           }).then((res) => {
				           	if (res.status == 200) {
                                console.log(res,'添加数据项')
				           		this.dialogVisible = false
				           		this.getData()
				           		this.dataDialog.name=''
                                this.dataDialog.tips=''
                                this.dataDialog.dataType=''
                                this.dataDialog.mustInputFlag = ''
                                this.dataDialog.maxLength = ''
				           	} else {
				           		obj.$message.error(res.message)
				           	}
				           })
				          } else {
				            console.log('error submit!!');
				            return false;
				          }
				        });
			},
			deleteRow(index, rows) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: '/api/v1/form/item/delete/'+rows.id,
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.msg)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			//全选
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			goback(){
				this.$router.push({
					path: '/home/formManage',
				})
			},
			//批量删除
			del() {
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				var list = []
				for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
					list.push(this.$refs.multipleTable.selection[i].id)
				}
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/banner/clear',
						params: {
							ids: list.toString(),
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.msg)
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		},
	}
</script>

<style scoped="scoped">
/deep/ .el-input__inner {
  height: 40px !important;
}

/deep/ .el-form-item__label {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
}

/deep/ .el-button--text {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}
/deep/ .el-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}

.chenggong {
  width: 49px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
  opacity: 0.7;
}

.fail {
  width: 33px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #76b67e;
  line-height: 24px;
}

/deep/ .el-message {
  z-index: 9999999999999;
}
</style>



// WEBPACK FOOTER //
// src/views/system/form/dataAdd.vue